// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("_assets/css/" + chunkId + ".min.css");